module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main', [(_vm.showFluxer[0]) ? _c('md-card', {
    attrs: {
      "md-with-hover": _vm.puedeVerDetalles
    }
  }, [_c('md-card-header', [_c('md-card-media', [_c('md-avatar', [_c('img', {
    attrs: {
      "src": _vm.showFluxer[0].photoURL,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("\n                      " + _vm._s(_vm.showFluxer[0].displayName) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_c('div', [(!_vm.feedback.isEspontaneo) ? _c('p', [_vm._v(_vm._s(_vm.texto))]) : _vm._e(), _vm._v(" "), (_vm.feedback.isEspontaneo) ? _c('p', [_vm._v("Feedback espontaneo")]) : _vm._e()])])])], 1), _vm._v(" "), _c('md-card-header', {
    staticClass: "footer"
  }, [_c('md-card-area', {
    attrs: {
      "md-inset": true
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', [(_vm.feedback.thanked) ? _c('span', {
    attrs: {
      "title": _vm.tituloAgradecido
    }
  }, [_c('md-icon', [_vm._v("thumb_up")])], 1) : _vm._e()]), _vm._v(" "), (_vm.feedback.completed) ? _c('md-layout', [_c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.feedback.completed, "DD/MM/YYYY")))])]) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06f6dc57"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feedback.vue
// module id = 366
// module chunks = 1